import { createBrowserClient } from '@supabase/ssr'

// Supabase 클라이언트 싱글톤
let supabaseClient: ReturnType<typeof createBrowserClient> | null = null

export function getSupabaseClient() {
  if (typeof window === 'undefined') {
    // 서버 사이드에서는 매번 새로 생성
    return createBrowserClient(
      process.env.NEXT_PUBLIC_SUPABASE_URL || 'http://placeholder.supabase.co',
      process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY || 'placeholder'
    )
  }

  if (!supabaseClient) {
    supabaseClient = createBrowserClient(
      process.env.NEXT_PUBLIC_SUPABASE_URL || 'http://placeholder.supabase.co',
      process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY || 'placeholder'
    )
  }
  return supabaseClient
}

export { getSupabaseClient as createClient }
